import * as Sentry from '@sentry/angular';
import { environment } from '../../../environments/environment';

const CLIENT_DSN =
  'https://91059e6c8aaf46e3b26a0034190dcc7b@o4511446909845504.ingest.us.sentry.io/4511446932520960';

export function isSentryEnabled(): boolean {
  return environment.envName !== 'development' || environment.useAnalyticsInDev === true;
}

export function initSentryIfEnabled(): void {
  if (!isSentryEnabled()) {
    return;
  }
  Sentry.init({
    dsn: CLIENT_DSN,
    sendDefaultPii: true,
    // El mismo proyecto de Sentry recibe los tres entornos; el tag `environment` es lo
    // único que los separa, así que sale directo de `envName`.
    environment: environment.envName,
  });
}
